import { jsx } from "react/jsx-runtime";
function PeopleMenuMore({ count }) {
  return /* @__PURE__ */ jsx("div", { className: "tlui-people-menu__more", children: "+" + Math.abs(count) });
}
export {
  PeopleMenuMore
};
//# sourceMappingURL=PeopleMenuMore.mjs.map
